import z from 'zod'

import { assetProperties } from './BaseModels'

export const assetParser = z.object(assetProperties)

export type Asset = z.infer<typeof assetParser>
